<template>
  <!--  -->
  <div class="bg-gray-100 px-4 pt-8 shadow-lg">
    <!--  -->
    <div class="relative bg-white w-full rounded-lg shadow">
      <!--  -->
      <div class="h-20 flex items-center border-gray-200 px-6">
        <!--  -->
        <button :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
          @click="RouterBack()">
          <!--  -->
          <i class="material-icons">chevron_left</i>
          <!--  -->
        </button>
        <!--  -->

        <!--  -->
        <div v-if="formData._id" class="text-xl font-semibold text-primary-600">
          {{ $t('update_order') }} (id: {{ formData.id }})
        </div>
        <!--  -->

        <!--  -->
        <div v-else class="text-xl font-semibold text-primary-500">
          {{ $t('new_order') }}
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="w-full flex item justify-center px-8">
        <!--  -->
        <div class="w-full flex flex-col gap-8 shadow-xs rounded-lg p-6">
          <!--  -->
          <div class="flex items-center gap-4">
            <!--  -->
            <span class="rounded-full h-12 w-12 bg-gray-200">
              <!--  -->
              <i class="material-icons p-3 text-primary-400">person</i>
              <!--  -->
            </span>
            <!--  -->

            <!--  -->
            <div class="text-base font-semibold text-gray-600">
              {{ $t('customer_information') }}
            </div>
            <!--  -->
          </div>

          <!--  -->
          <div class="flex flex-col gap-6">
            <!--  -->
            <div class="flex justify-between gap-4">
              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="customerFullName" class="bg-white text-gray-700 px-1">{{ $t('full_name') }}
                      <!--  -->
                      <span :class="$colors.required">*</span>
                      <!--  -->
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <p>
                  <!--  -->
                  <input id="customerFullName" autocomplete="false" tabindex="0" type="text"
                    v-model="formData.customer.fullName" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="phone" class="bg-white text-gray-700 px-1">{{ $t('phone') }}
                      <!--  -->
                      <span :class="$colors.required">*</span></label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <!--  -->
                  <input id="phone" autocomplete="false" tabindex="0" type="text" v-model="formData.customer.phone"
                    class="py-2 text-xs px-2 outline-none block h-full w-full" />
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="flex justify-between gap-4">
              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="country" class="bg-white text-gray-700 px-1">{{ $t('country') }}</label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <!--  -->
                  <v-select @input="setSelected" v-model="formData.customer.country" :options="warehouses" label="name"
                    :disabled="formData && formData._id ? true : false">
                    <!--  -->
                    <template slot="option" slot-scope="option">
                      <!--  -->
                      <img class="flag-img" :src="$f.getCountryCode(option.code)" />
                      <!--  -->
                      {{ option.name }}
                      <!--  -->
                    </template>
                    <!--  -->
                  </v-select>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="city" class="bg-white text-gray-700 px-1">{{ $t('city') }}
                      <!--  -->
                      <span :class="$colors.required">*</span>
                      <!--  -->
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <!--  -->
                  <v-select @input="setSelectedCity" v-model="formData.customer.city" :options="cities"></v-select>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="flex justify-between gap-4">
              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded"
                v-if="formData.customer.city && currentUser.type !== 'Seller'">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="Frais" class="bg-white text-gray-700 px-1">{{ $t('shipping_cost') }}
                      <!--  -->
                      <sup>({{ currentCurrency }})</sup>
                      <!--  -->
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <!--  -->
                  <input id="Frais" autocomplete="false" disabled tabindex="0"
                    :value="(formData.feesShip && formData.feesShip == -1) || !formData._id ? feesShip.price : formData.feesShip"
                    type="text" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="customerAddress" class="bg-white text-gray-700 px-1">{{ $t('address') }}</label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <!--  -->
                  <textarea id="customerAddress" autocomplete="false" tabindex="0" type="text"
                    v-model="formData.customer.address"
                    class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="w-full flex item justify-center px-8 pt-8">
        <!--  -->
        <div class="w-full flex flex-col gap-8 shadow-xs rounded-lg p-6">
          <!--  -->
          <div class="flex items-center gap-4">
            <!--  -->
            <span class="rounded-full h-12 w-12 bg-gray-200">
              <!--  -->
              <i class="material-icons p-3 text-primary-400">local_grocery_store</i>
              <!--  -->
            </span>
            <!--  -->

            <!--  -->
            <div class="text-base font-semibold text-gray-600">
              {{ $t('order_information') }}
            </div>
            <!--  -->
          </div>

          <!--  -->
          <div class="flex flex-col gap-6">
            <!--  -->
            <div class="flex justify-between gap-4">
              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="source" class="bg-white text-gray-700 px-1">{{ $t('order_source') }}</label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <!--  -->
                  <input id="source" autocomplete="false" tabindex="0" type="text" v-model="formData.source"
                    class="py-2 text-xs px-2 outline-none block h-full w-full" />
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="sourceLink" class="bg-white text-gray-700 px-1">{{ $t('order_source_link') }}</label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <!--  -->
                  <input id="sourceLink" autocomplete="false" tabindex="0" type="text" v-model="formData.sourceLink"
                    class="py-2 text-xs px-2 outline-none block h-full w-full" />
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="flex justify-between gap-4">
              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="date" class="bg-white text-gray-700 px-1">{{ $t('order_date') }}
                      <!--  -->
                      <span :class="$colors.required">*</span>
                      <!--  -->
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <!--  -->
                  <input autocomplete="false" tabindex="0" id="date" type="datetime-local" v-model="formData.date"
                    class="py-2 text-xs px-2 outline-none block h-full w-full" />
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="customerAddress" class="bg-white text-gray-700 px-1">{{ $t('comment') }}</label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <!--  -->
                  <textarea id="customerAddress" autocomplete="false" tabindex="0" type="text"
                    v-model="formData.comment"
                    class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="flex justify-between gap-4">
              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded"
                v-if="currentUser.type != 'Seller'">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="seller" class="bg-white text-gray-700 px-1">
                      {{ $t('seller') }}
                      <!--  -->
                      <span :class="$colors.required">*</span>
                      <!--  -->
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <!--  -->
                  <v-select label="company" @input="changeSeller" :disabled="formData._id ? true : false"
                    v-model="formData.seller" :options="sellers" @search="searchUsers($event, 'Seller')"></v-select>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded"
                :class="!formData._id && formData.seller && !formData.teleConsultant ? 'animation-pulse' : ''"
                v-if="currentUser.type != 'Seller' && currentUser.subType != 'Commercial' && formData.customer.country">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="seller" class="bg-white text-gray-700 px-1"> {{ $t('select_teleconsultant') }}
                      <!--  -->
                      <span :class="$colors.required">*</span>
                      <!--  -->
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <!--  -->
                  <v-select label="fullName" :options="teleConsultants" v-model="formData.teleConsultant"
                    @search="searchUsers($event, 'TeleConsultant')"></v-select>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="flex justify-between gap-4">
              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded"
                v-if="formData.customer && formData.customer.country && sellerDataWarehouseSettings && sellerDataWarehouseSettings.confirmation">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="already_confirmed" class="bg-white text-gray-700 px-1">{{ 'already_confirmed' | t
                      }}</label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p class="flex items-center justify-center w-full">
                  <!--  -->
                  <label for="toogle3" class="cursor-pointer py-1">
                    <!--  -->
                    <div class="relative">
                      <!--  -->
                      <input id="toogle3" v-model="formData.is_confirmed" type="checkbox" class="hidden" />
                      <!--  -->
                      <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner" />
                      <!--  -->
                      <div class="toggle__dot-3 absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0" />
                      <!--  -->
                    </div>
                    <!--  -->
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded"
                v-if="currentUser.type != 'Seller'">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="upsel" class="bg-white text-gray-700 px-1">Upsel</label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p class="flex items-center justify-center w-full">
                  <!--  -->
                  <label :for="'toogle1'" class="cursor-pointer py-1">
                    <!--  -->
                    <div class="relative">
                      <!--  -->
                      <input :id="'toogle1'" type="checkbox" class="hidden" v-model="formData.upsel" />
                      <!--  -->
                      <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                      <!--  -->
                      <div :class="'toggle__dot-1'"
                        class="absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0">
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!-- 
            <div class="flex justify-between gap-4" v-if="formData._id && formData.status && formData.status.name.toLowerCase() === 'confirmed'">
              <div class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="exchange" class="bg-white text-gray-700 px-1">{{ 'exchange' |t }}</label>
                  </p>
                </div>
                <p class="flex items-center justify-center w-full">
                  <label for="toogle4" class="cursor-pointer py-1">
                    <div class="relative">
                      <input id="toogle4" v-model="formData.exchange.is_confirmed" type="checkbox" class="hidden" />
                      <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner" />
                      <div class="toggle__dot-3 absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0" />
                    </div>
                  </label>
                </p>
              </div>

              <div class="w-1/2 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded" v-if="formData.exchange.is_confirmed">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="old_tracking" class="bg-white text-gray-700 px-1">{{ $t('old_tracking_number') }}</label>
                  </p>
                </div>
                <p>
                  <input id="old_tracking" autocomplete="false" tabindex="0" type="text" v-model="formData.exchange.oldTrackingNumber" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                </p>
              </div>
            </div> -->

          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="w-full flex item justify-center px-8 pt-8">
        <!--  -->
        <div class="w-full flex flex-col gap-8 shadow-xs rounded-lg p-6">
          <!--  -->
          <div class="w-full flex flex-wrap gap-8  justify-between items-center">
            <!--  -->
            <div class="flex  items-center gap-4">
              <!--  -->
              <span class="block rounded-full h-12 w-12 bg-gray-200">
                <i class="material-icons p-3 text-primary-500">local_mall</i>
              </span>
              <!--  -->

              <!--  -->
              <span class="block text-base font-semibold text-gray-600">{{ $t('products') }}</span>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <button @click="OpenPopUp"
              class="flex text-white max-w-sm rounded-md text-center bg-primary-600 py-2 px-8 items-center"
              :disabled="isDisabled">
              {{ $t('select_product') }}
            </button>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="w-full">

            <!--  -->
            <div class="mt-4 overflow-x-auto">
              <!--  -->
              <table v-if="formData.details && this.calculate.length > 0" class="min-w-full leading-normal">
                <!--  -->
                <thead>
                  <!--  -->
                  <tr>
                    <!--  -->
                    <th
                      class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                      {{ $t('name') }}
                    </th>
                    <!--  -->

                    <!--  -->
                    <th
                      class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                      {{ $t('unit_price') }}
                    </th>
                    <!--  -->

                    <!--  -->
                    <th
                      class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                      {{ $t('quantity') }}
                    </th>
                    <!--  -->

                    <!--  -->
                    <th
                      class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                      {{ $t('total') }}
                    </th>
                    <!--  -->

                    <!--  -->
                    <th
                      class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                      {{ $t('actions') }}
                    </th>
                    <!--  -->
                  </tr>
                  <!--  -->
                </thead>
                <!--  -->

                <!--  -->
                <tbody v-for="(item, index) in formData.details" :key="index">
                  <!--  -->
                  <tr>
                    <!--  -->
                    <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                      <!--  -->
                      <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900 font-bold">
                        {{ item.product.name }}
                        <!--  -->
                        <p
                          v-if="(item.product.variantes && item.product.variantes.length > 0 && item.product.source) || (item.variante && item.variante.id)">
                          <!--  -->
                          <small>Varinate: {{ item.variante ? item.variante.name : item.product.source.name }}</small>
                          <!--  -->
                        </p>
                        <!--  -->
                      </div>
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                      <!--  -->
                      <div>
                        <!--  -->
                        <input @input="calculateQtePrice(index, 'total')" autocomplete="off" tabindex="0" min="0"
                          type="number" v-model.number="item.unitPrice"
                          class="border border-orange-600 py-2 text-xs px-2 outline-none block h-full w-fit-content" />
                        <!--  -->
                      </div>
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="px-8 py-2 whitespace-no-wrap border-b border-gray-200">
                      <!--  -->
                      <div class="flex md:space-x-2">
                        <!--  -->
                        <button :class="$colors.textPrimary"
                          class="bg-primary-600 rounded-md w-6 h-6 flex items-center focus:outline-none"
                          @click="addQuantity(index)">
                          <!--  -->
                          <span class="font-bold text-2xl text-white">
                            <!--  -->
                            <i class="material-icons mt-2">add</i>
                            <!--  -->
                          </span>
                          <!--  -->
                        </button>
                        <!--  -->

                        <!--  -->
                        <span :class="$colors.textPrimary"
                          class="text-gray-700 text-sm h-6 flex items-center focus:outline-none">
                          <!--  -->
                          <input class="focus:outline-none text-center min-w-content" type="text"
                            v-model="item.quantity" @input="calculateQtePrice(index, calculate[index].type)" />
                          <!--  -->
                        </span>
                        <!--  -->

                        <!--  -->
                        <button :class="$colors.textPrimary" @click="removeQuantity(index)"
                          class="bg-primary-600 rounded-md w-6 h-6 text-white flex items-center focus:outline-none">
                          <!--  -->
                          <span class="font-bold text-2xl text-white mt-1">
                            <!--  -->
                            <i class="material-icons">remove</i>
                            <!--  -->
                          </span>
                          <!--  -->
                        </button>
                        <!--  -->
                      </div>
                      <!--  -->
                      <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"></div>
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class=" py-2 whitespace-no-wrap border-b border-gray-200 text-center w-24 max-w-none min-w-0">
                      <!--  -->
                      <div class="flex gap-4 md:gap-2 w-content items-center ">
                        <!--  -->
                        <input @input="calculateQtePrice(index, 'price')" autocomplete="off" min="0" type="number"
                          v-model.number="calculate[index].price"
                          class="border border-orange-600 py-2 text-xs px-2 outline-none block h-full " />
                        <!--  -->
                        <sup class="text-black">({{ currentCurrency }})</sup>
                        <!--  -->
                      </div>
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="py-4 whitespace-no-wrap border-b border-gray-200">
                      <!--  -->
                      <div class="flex justify-center">
                        <!--  -->
                        <button @click="removeProduct(item, index)" :class="$colors.actionTable"
                          class="rounded-full flex focus:outline-none w-8 h-8 mr-3 mt-1">
                          <!--  -->
                          <i class="material-icons mx-1">delete</i>
                          <!--  -->
                        </button>
                        <!--  -->
                      </div>
                      <!--  -->
                    </td>
                    <!--  -->
                  </tr>
                  <!--  -->
                </tbody>
                <!--  -->

                <!--  -->
                <tbody>
                  <!--  -->
                  <tr>
                    <!--  -->
                    <td colspan="4" class="px-6 text-right py-2 whitespace-no-wrap border-gray-200">
                      <!--  -->
                      <div class="text-xs leading-5 capitalize px-2 rounded-full font-bold text-gray-900">
                        {{ $t('total_price') }}:
                        {{ TotalPrice() }}
                        <!--  -->
                        <sup class="text-black">({{ currentCurrency }})</sup>
                        <!--  -->
                      </div>
                      <!--  -->
                    </td>
                    <!--  -->
                  </tr>
                  <!--  -->
                </tbody>
                <!--  -->
              </table>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="bg-white fixed bottom-0 right-0 left-60 z-50 w-full shadow-lg">
        <!--  -->
        <div class="flex justify-end items-center gap-4 py-4 px-8 ml-[20vw]">
          <!--  -->
          <button @click="duplicate"
            class="loidingconfirm relative border border-solid border-primary-600 text-primary-600 hover:bg-primary-700 hover:text-gray-100 hover:shadow-inner rounded focus:outline-none outline-none transition-all duration-300 px-3 w-full md:w-1/6 py-2"
            :class="loading ? 'noselect' : ''" v-if="formData._id && currentUser.type !== 'TeleConsultant'">
            <!--  -->
            <loading :active.sync="loadingDuplicate" :is-full-page="fullPage"></loading>
            <!--  -->
            {{ $t('duplicate') }}
          </button>
          <!--  -->

          <!--  -->
          <button @click="save"
            class="loidingconfirm relative border border-solid border-primary-600 bg-primary-600 text-gray-100 hover:bg-primary-700 hover:shadow-inner rounded focus:outline-none outline-none transition-all duration-300 px-3 w-full md:w-1/6 py-2"
            :class="loading ? 'noselect' : ''">
            <!--  -->
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
            <!--  -->
            {{ $t('save') }}
          </button>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <vue-modal-2 name="myModal" :headerOptions="{ title: $t('add_products') }" :noFooter="true" modalSize="lg"
        @on-close="closePopUp">
        <!--  -->
        <div class="flex flex-col w-full h-auto p-5 pt-0 mb-12">
          <!--  -->
          <div class="flex w-full h-auto justify-center items-center">
            <!--  -->
            <div class="flex mb-2 w-full h-auto py-2 justify-center items-center text-2xl font-bold">
              <!--  -->
              <span class="w-screen md:w-full h-10 cursor-pointer border border-gray-200 rounded text-sm flex">
                <!--  -->
                <input type="search" name="search" v-model="searchText" placeholder="Search"
                  class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none" />
                <!--  -->
                <i class="material-icons text-orange-400 m-2 mr-5 text-lg w-4 h-4">search</i>
                <!--  -->
              </span>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div>
            <!--  -->
            <div v-if="products.length <= 0" class="py-2">
              <!--  -->
              <span class="w-full flex justify-center text-center py-20 border-b border-gray-200 text-base">
                <!--  -->
                <p class="font-semibold flex text-orange-500 whitespace-no-wrap">
                  <!--  -->
                  <span class=""> {{ $t('no_products_found') }}</span>
                  <!--  -->
                </p>
                <!--  -->
              </span>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div v-for="(item, index) in resultSearchUsers" :key="index" :value="item._id"
              class="flex w-full space-x-12 h-auto py-1 px-8 rounded border border-gray-300 mb-2">
              <!--  -->
              <div>
                <!--  -->
                <input type="checkbox" v-model="item.check" :class="'product-' + index"
                  class="form-checkbox checkallbbox mt-6 h-5 w-5 text-orange-500 border-orange-500"
                  @change="addProductsToTemp(item, index)" />
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div>
                <!--  -->
                <img :alt="item.name"
                  :src="item.picture || 'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"
                  class="h-16 w-16 rounded-md mx-auto" />
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="w-full">
                <!--  -->
                <h3 class="text-gray-80 mt-1">{{ item.name }}</h3>
                <!--  -->
                <p class="text-gray-600 text-xs">
                  {{ exceptDes(item.description) }}
                </p>
                <!--  -->
                <p v-if="item.variantes && item.variantes.length > 0">
                  <!--  -->
                  <v-select label="name" placeholder="Sélectionnez variante ..." :disabled="item.check"
                    v-model="item.source" :options="item.variantes" @input="selectAutoVariant(item, index)"
                    class="border border-gray-500 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"></v-select>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="modal-footer px-5 border0-t text-right">
          <!--  -->
          <button @click="closePopUp"
            class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">
            {{ $t('cancel') }}
          </button>
          <!--  -->

          <!--  -->
          <button @click="ConfirmOperation"
            class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-orange-500 py-2 px-8 items-center focus:outline-none md:float-right">
            {{ $t('confirm') }}
          </button>
          <!--  -->
        </div>
        <!--  -->
      </vue-modal-2>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  data() {
    return {
      calculate: [],
      formData: {
        source: '',
        sourceLink: '',
        upsel: false,
        is_confirmed: false,
        totalPrice: 0,
        date: this.$moment(Date.now()).format('yyyy-MM-DD HH:mm'),
        customer: {
          fullName: '',
          phone: '',
          city: '',
        },
        details: [],
        status: '',
        seller: null,
        zone: null,
        teleConsultant: null,
        exchange: {
          is_confirmed: false,
          oldTrackingNumber: ''
        }
      },
      currentUser: {
        role: {},
      },
      searchText: '',
      quantity: 0,
      status: [],
      products: [],
      show_modal: true,
      limit: 10,
      warehouseId: null,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
      selectedProduct: [],
      infoChange: {
        Oldcity: '',
        Newcity: '',
        Oldstatus: '',
        Newstatus: '',
        detailsOld_length: null,
        detailsNew_length: null,
      },
      numberItemRepeated: 0,
      sellers: [],
      isDisabled: true,
      sellerExists: false,
      options: this.$countries,
      selectCountry: '',
      warehouses: [],
      currentCurrency: '',
      cities: [],
      feesShip: { price: 0 },
      warehousesParent: [],
      loading: false,
      loadingDuplicate: false,
      fullPage: false,
      sellerDataWarehouseSettings: null,
      teleConsultants: []
    };
  },
  async mounted() {
    await this.getUser();
    if (this.currentUser.type == 'Seller') {
      this.formData.seller = this.currentUser;
      if (this.formData.seller) this.isDisabled = false;
    }

    await this.getStatus();
    await this.dataToEdit();
    await this.getWarehouses();

    if (this.$route.query.index) {
      document.getElementsByTagName('body')[0].style = 'padding-right: inherit;overflow: inherit;';
    }

    if (!this.$route.params.id) {
      const country = this.warehouses[0];
      this.formData.customer.country = country;
      this.setSelected(country);
    }
  },
  computed: {
    resultSearchUsers() {
      if (this.searchText) {
        return this.products.filter(product => {
          var regex = new RegExp(this.searchText, 'i');

          if (regex.test(product.name)) return regex.test(product.name);
          else if (regex.test(product.code)) return regex.test(product.code);
          else if (regex.test(product.code1)) return regex.test(product.code1);
          else return regex.test(product.code2);
        });
      } else {
        return this.products;
      }
    },
  },
  methods: {
    RouterBack: function () {
      this.$router.back();
    },
    setSelectedVariants(variante, idProduct) {
      let product = this.products.find(p => {
        return p._id.toString() === idProduct.toString();
      });
      product.variante = variante;
    },
    async getCurrency() {
      await this.$store.dispatch('wharhouse/getCurrency').then(res => {
        this.currency = res;
      });
    },
    getElementInArray(data, value) {
      var result = data.filter(function (o) {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null;
    },
    async getWarehouses() {
      const filter = { limit: 1000, is_primary: true };
      const res = await this.$server.search('warehouses', filter);
      if (res.content.results) {
        let data = res.content.results;
        for (let i in data) {
          this.warehouses.push({
            name: this.$f.getCountryNameByCode(this.options, data[i].country),
            code: data[i].country,
          });
        }
      } else this.warehouses = [];
    },
    async getCities(country) {
      const resCities = await this.$server.get('zones', {
        allCities: true,
        country: country,
      });
      if (resCities.content.length > 0) this.cities = resCities.content;
      else this.cities = [];
    },
    async getWarehouseByCity(zone) {
      const resWarehouses = await this.$server.search('warehouses', {
        'zones.id': zone,
        country: this.selectCountry,
        parent: true,
        is_primary: false,
      });
      if (resWarehouses.content.results)
        this.warehousesParent = resWarehouses.content.results;
      else this.warehousesParent = [];
    },
    async getCurrencyByCountry(country) {
      const resW = await this.$server.get('warehouses', { country: country });
      this.currentCurrency = resW.content.currency;
      this.warehouseId = resW.content._id;
      if (this.formData.seller && this.formData.seller.settings.length > 0)
        this.sellerDataWarehouseSettings = this.getElementInArray(
          this.formData.seller.settings,
          this.warehouseId,
        );
    },
    async setSelected(country) {
      if (country) {
        this.formData.details = [];
        this.formData.customer.country = country.name;

        this.selectCountry = country.code;
        this.formData.customer.city = null;

        if (this.currentUser.type != 'Seller') {
          await this.getSellers(country.code);
        }

        await this.getCities(country.code);
        await this.getCurrencyByCountry(country.code);

        await this.getTeleconsultant(country.code);
      }
    },
    async getFeesShipByCity(seller = null, city) {
      const res = await this.$server.search('zones', { cities: city });
      if (res.content.results) {
        this.feesShip.price = res.content.results[0].price;
        this.feesShip._id = res.content.results[0]._id;
        this.formData.zone = res.content.results[0]._id;
        if (seller && seller.fees && seller.fees.length > 0) {
          const currentSettingSeller = this.getElementInArray(
            seller.fees,
            this.warehouseId,
          );
          if (
            currentSettingSeller &&
            currentSettingSeller.shippingzones &&
            currentSettingSeller.shippingzones.length > 0
          ) {
            this.feesShip.price = this.getPriceByZone(
              res.content.results[0]._id,
              currentSettingSeller.shippingzones,
            );
          }
        }
      }
    },
    async setSelectedCity(city) {
      if (city) {
        await this.getFeesShipByCity(this.formData.seller, city);
        if (this.formData.zone)
          await this.getWarehouseByCity(this.formData.zone);
      } else {
        this.feesShip = { price: 0 };
        this.warehousesParent = [];
        this.formData.zone = null;
      }
    },
    exceptDes(text) {
      if (text && text.length > 60) text = text.substring(0, 60) + '...';
      return text;
    },
    TotalPrice() {
      let Total = 0;
      for (const element of this.formData.details) {
        Total += element.unitPrice * element.quantity;
      }
      this.formData.totalPrice = Total.toFixed(0);
      return Total.toFixed(0);
    },
    async getUser() {
      const res = await this.$server.me('users');
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },
    async getProducts() {
      if (this.formData.seller) {
        const filters = {
          seller: this.formData.seller._id,
          'details.warehouse': this.warehouseId,
          warehousesParent: this.warehousesParent.map(el => el._id),
          limit: 1000,
        };

        const res = await this.$server.search('products', filters);
        if (res.content.results) {
          this.products = res.content.results;
          this.paginate.total = res.content.total;
          this.paginate.lastpage = res.content.last_page;
          this.paginate.per_page = res.content.per_page;
          this.paginate.currentpage = res.content.current_page;

          for (let i in this.products) {
            this.products[i].seller = this.products[i].seller._id;
            this.products[i].source = null;
            const resProductW = this.getElementInArray(
              this.products[i].details.filter(function (obj) {
                return obj.warehouse;
              }),
              this.warehouseId,
            );

            if (resProductW && resProductW.price) {
              this.products[i].price = resProductW.price;
            }

            if (resProductW.variantes && resProductW.variantes.length > 0) {
              this.products[i].variantes = resProductW.variantes.map(el => ({ id: el.id, name: el.name, picture: el.picture }));
            }
          }
        } else this.products = [];
      } else {
        alert(this.$t('must_select_seller'), 'warning');
      }
    },
    async getStatus() {
      const res = await this.$server.search('status');
      if (res.content.results) this.status = res.content.results;
      else this.status = [];
    },
    SumTotalPrice(data) {
      let total = 0;
      for (let i in data) {
        total += data[i].quantity * data[i].unitPrice;
      }
      return total.toFixed(0);
    },
    checkingData() {
      let dataRes = null;
      for (const i in this.formData.details) {
        if (this.formData.details[i].product && this.formData.details[i].product.variantes && this.formData.details[i].product.variantes.length > 0 && !this.formData.details[i].product.source) {
          dataRes = `Svp sélectionner une variante dans ce produit: ${this.formData.details[i].product.name}`;
          return dataRes;
        }

        if (this.formData.details[i].product && this.formData.details[i].product.variantes && this.formData.details[i].product.variantes.length > 0 && this.formData.details[i].product.source) {
          this.formData.details[i].variante = this.formData.details[
            i
          ].product.source;
        }
      }

      return dataRes;
    },
    async save() {
      if (this.formData._id) {
        if (this.checkingData()) {
          this.$toast.warning(this.checkingData());
          return false;
        }

        this.formData.totalPrice = this.SumTotalPrice(this.formData.details);
        this.formData.customer.phone = this.formData.customer.phone.replace(
          /[^\d]/g,
          '',
        );

        this.formData.customer.country = this.selectCountry;
        if (this.formData.customer.country === 'MA') {
          let strFirstThree = this.formData.customer.phone.substring(0, 4);
          if (strFirstThree.indexOf('212') === -1)
            this.formData.customer.phone = '212' + this.formData.customer.phone;
        }

        this.infoChange.Newcity = this.formData.customer.city;
        this.infoChange.detailsNew_length = this.formData.details.length;
        this.infoChange.Oldstatus = this.formData.status._id;
        this.formData.infoChange = this.infoChange;

        this.loading = true;
        const data = await this.$server.update('orders', this.formData);
        this.loading = false;

        if (data && data._id) {
          this.infoChange.Oldcity = data.customer.city;
          this.infoChange.detailsOld_length = data.details.length;
          this.formData.customer.country = this.$f.getCountryNameByCode(
            this.options,
            this.selectCountry,
          );

          alert(this.$t('order_updated'), 'success');
          await this.dataToEdit('new');

          if (this.$route.query.index) {
            const filter = this.$f.QueryStringToobject();
            if ((filter.status && filter.status.toString() === this.infoChange.Newstatus.toString()) || !filter.status) {
              this.$router
                .push({
                  name: 'orders',
                  path: '/orders',
                  query: this.$f.QueryStringToobject(),
                })
                .catch(() => { });
            } else {
              this.$router
                .push({
                  path: '/orders',
                  query: {
                    name: this.formData.customer.phone,
                    limit: 50,
                    country: this.formData.customer.country,
                    index: this.formData._id,
                  },
                })
                .catch(() => { });
            }
          }
        } else alert(data, 'warning');
      } else {
        if (this.checkData()) {
          if (this.checkingData()) {
            this.$toast.warning(this.checkingData());
            return false;
          }

          this.formData.customer.country = this.selectCountry;
          this.formData.totalPrice = this.SumTotalPrice(this.formData.details);
          this.formData.customer.phone = this.formData.customer.phone.replace(
            /[^\d]/g,
            '',
          );

          let dataWhrahouseSetting = null;
          if (this.formData.seller.settings.length > 0)
            dataWhrahouseSetting = this.getElementInArray(
              this.formData.seller.settings,
              this.warehouseId,
            );

          if (!dataWhrahouseSetting || (dataWhrahouseSetting && !dataWhrahouseSetting.confirmation && !dataWhrahouseSetting.fulfillement && !dataWhrahouseSetting.shipping)) {
            alert("vous n'avait pas activé aucun services veuillez contacter administration vex", 'warning');
            this.loading = false;
            return false;
          }

          if (this.warehousesParent.length > 0) {
            this.formData.warehousesParent = this.warehousesParent;
          }

          this.formData.createManualy = true;
          this.loading = true;

          const data = await this.$server.create('orders', this.formData);
          this.loading = false;

          if (data && data._id) {
            this.selectCountry = '';
            this.warehousesParent = [];
            this.formData.customer.country = '';
            this.formData = {
              upsel: false,
              is_confirmed: false,
              customer: {
                fullName: '',
                phone: '',
                city: '',
              },
              details: [],
            };

            this.calculate = [];

            if (this.currentUser.type == 'Seller') {
              this.formData.seller = this.currentUser;
              if (this.formData.seller) this.isDisabled = false;
            }

            if (!this.$route.params.id) {
              const country = this.warehouses[0];
              this.formData.customer.country = country;
              this.setSelected(country);
            }

            alert(this.$t('order_created'), 'success');
          } else alert(data.content ? data.content : data, 'warning');
        } else alert(this.$t('all_required_field'), 'warning');
      }
    },
    async duplicate() {
      if (this.$route.params.id) {
        try {
          this.loadingDuplicate = true;

          const { content: oldOrder } = await this.$server.get('orders', {
            id: this.$route.params.id,
          });

          if (!oldOrder) {
            throw new Error("Order not found");
          }

          const duplicatedOrder = {
            id: `${Date.now().toString(36).slice(2)}py`,
            sourceLink: oldOrder.sourceLink,
            upsel: oldOrder.upsel,
            totalPrice: oldOrder.totalPrice,
            date: oldOrder.date,
            customer: {
              fullName: oldOrder.customer.fullName,
              country: oldOrder.customer.country,
              phone: oldOrder.customer.phone,
              address: oldOrder.customer.address,
              city: oldOrder.customer.city,
            },
            details: oldOrder.details,
            status: null,
            seller: oldOrder.seller,
            zone: oldOrder.zone
          };

          const { content: status } = await this.$server.get('status', { name: 'Pending' });
          duplicatedOrder.status = status;

          const newOrder = await this.$server.create('orders', duplicatedOrder);

          this.loadingDuplicate = false;

          if (newOrder) {
            this.$router.push({ path: '/orders', query: { index: newOrder._id } });
          }

        } catch (error) {
          console.error("Error duplicating the order:", error);
          this.loadingDuplicate = false;
        }
      }
    },
    checkDetails() {
      let exitError = false;
      for (let index = 0; index < this.formData.details.length; index++) {
        const orderLine = this.formData.details[index];

        if (!orderLine.unitPrice || (orderLine.unitPrice && orderLine.unitPrice == '0')) {
          exitError = true;
          alert(
            `Unit price pour ce produit est required ${orderLine.product.name}`,
            'warning',
          );
          break;
        }
      }
      if (exitError) return true;
      else return false;
    },
    checkData() {
      if (
        this.formData.date &&
        this.formData.customer.country &&
        this.formData.customer.phone &&
        this.formData.customer.city &&
        this.formData.zone &&
        this.formData.details.length > 0 &&
        this.formData.customer
      )
        return true;
      else return false;
    },
    removeProduct(data) {
      this.$confirm(this.$t('confirm_delete_product')).then(async () => {
        const productIndex = this.formData.details.findIndex(
          o => o.product._id === data.product._id,
        );

        if (productIndex !== -1) {
          this.formData.details.splice(productIndex, 1);
          this.calculate.splice(productIndex, 1);
        }

        data.product.check = false;
        alert(this.$t('product_deleted'), 'success');
      });
    },
    checkPrice(data) {
      if (!data.price || parseInt(data.price) == 0 || typeof data.price == 'undefined') {
        return true;
      } else return false;
    },
    selectAutoVariant(data, id) {
      data.check = true;
      let column = document.querySelector('.product-' + id);
      column.checked = true;
      this.addProductsToTemp(data, id);
    },
    addProductsToTemp(data, id) {
      if (data.check) {
        if (data.isPack && Array.isArray(data.packs) && data.packs.length > 0) {
          const totalPrice = this.formData.details.reduce(
            (total, { unitPrice }) => total + unitPrice,
            0
          );
          const totalQuantity = this.formData.details.reduce(
            (total, { quantity }) => total + quantity,
            0
          );
          const totalPacks = data.packs.reduce(
            (total, { unitPrice }) => total + unitPrice,
            0
          );

          if (totalPrice && totalPacks !== totalPrice) {
            const equalUnitPrice = +(totalPrice / data.packs.length).toFixed(2);

            data.packs.forEach(pack => {
              pack.unitPrice = equalUnitPrice;
              pack.quantity = totalQuantity;
            });
          }

          this.selectedProduct.push(...data.packs);
          return;
        }

        if (data.variantes && data.variantes.length > 0 && !data.source) {
          this.$toast.warning('Svp sélectionner une variante');
          data.check = false;
          let column = document.querySelector('.product-' + id);
          column.checked = false;
          return false;
        }

        var detail = { product: data, unitPrice: 0, quantity: 1 };

        if (data.category) {
          if (data.category._id) {
            detail.category = data.category._id;
          }
        }

        let found = 0;
        for (let i = 0; i < this.formData.details.length; i++) {
          if (this.formData.details[i].product._id == data._id) {
            if ((!this.formData.details[i].product.source && !this.formData.details[i].variante) ||
              (this.formData.details[i].product.source && this.formData.details[i].product.source.id === data.source.id) ||
              (this.formData.details[i].variante && this.formData.details[i].variante.id === data.source.id)) {
              found = found + 1;
              this.numberItemRepeated = this.numberItemRepeated + 1;
            }
          }
        }

        if (found < 1) {
          this.selectedProduct.push(detail);
        }
      } else {
        let pos = this.selectedProduct.map(function (e) { return e.product._id; }).indexOf(data._id);
        this.selectedProduct.splice(pos, 1);
        this.$nextTick(() => { this.$forceUpdate(); });
      }
    },
    addQuantity(index) {
      const item = this.formData.details[index];
      item.quantity++;
      this.calculateQtePrice(index, this.calculate[index].type);
    },
    removeQuantity(index) {
      const item = this.formData.details[index];
      if (item.quantity >= 1) {
        item.quantity--;
        this.calculateQtePrice(index, this.calculate[index].type);
      }
    },
    calculateQtePrice(index, type) {
      const item = this.formData.details[index];
      if (type === 'total') {
        this.calculate[index].type = 'total';
        
        this.calculate[index].price = (item.unitPrice * item.quantity).toFixed(0);

      } else if (type === 'price' && item.quantity > 0) {
        this.calculate[index].type = 'price';
        item.unitPrice = (this.calculate[index].price / item.quantity)
      }
    },
    async OpenPopUp() {
      if (!this.formData.customer.country) {
        alert(this.$t('select_country'), 'warning');
        return false;
      }

      if (!this.formData.customer.city) {
        alert(this.$t('select_city'), 'warning');
        return false;
      }

      if (this.formData.seller) {
        await this.getProducts({});
        if (this.products.length > 0) {
          this.$vm2.open('myModal');
        } else {
          if (this.currentUser.type != 'Seller')
            alert(this.$t('no_products_seller'), 'warning');
          else alert(this.$t('no_product_added'), 'warning');
        }
      }
    },
    ConfirmOperation() {
      this.formData.details.push(...this.selectedProduct);
      this.calculate.push(
        ...this.selectedProduct.map(() => ({ price: 0, type: 'total' }))
      );

      this.formData.details.forEach((_, index) => {
        this.calculateQtePrice(index, this.calculate[index].type);
      });

      this.selectedProduct = [];

      if (this.numberItemRepeated > 0) {
        alert(this.$t('product_already_added'), 'success');
      }

      this.numberItemRepeated = 0;
      this.$vm2.close('myModal');
    },
    closePopUp() {
      this.$vm2.close('myModal');
    },
    async dataToEdit(newData = null) {
      if (this.$route.params.id) {
        const editData = await this.$server.get('orders', {
          id: this.$route.params.id,
        });

        this.formData = editData.content;

        this.calculate = this.formData.details.map(detail => ({
          price: (detail.unitPrice * detail.quantity).toFixed(0),
          type: 'total',
        }));

        this.infoChange.Oldcity = editData.content.customer.city;
        this.infoChange.detailsOld_length = editData.content.details.length;

        if (newData) this.infoChange.Newstatus = this.formData.status._id;
        if (this.formData.seller) this.isDisabled = false;

        this.selectCountry = this.formData.customer.country;
        this.formData.customer.country = this.$f.getCountryNameByCode(
          this.options,
          this.formData.customer.country,
        );

        this.formData.date = this.$moment(this.formData.date).format(
          'yyyy-MM-DDTHH:mm'
        );

        if (this.currentUser.type != 'Seller') {
          await this.getSellers(this.selectCountry);
        }

        await this.getCurrencyByCountry(this.selectCountry);
        await this.getCities(this.selectCountry);

        if (this.formData.feesShip && this.formData.feesShip == -1) {
          await this.getFeesShipByCity(this.formData.seller, this.formData.customer.city);
        }

        await this.getTeleconsultant(this.selectCountry);
      }
    },
    async getSellers(country) {
      const filter = {
        type: 'Seller',
        limit: 10,
        countries: country,
      };

      const res = await this.$server.search('users', filter);
      if (res.content.results) {
        this.sellers = res.content.results;
        this.sellerExists = true;
      } else this.sellers = [];
    },
    async getTeleconsultant(code) {
      const filter = {
        type: 'TeleConsultant',
        limit: 10,
        countries: code
      };

      const res = await this.$server.find("users", filter);
      if (res && res.content.results) {
        this.teleConsultants = res.content.results;
      } else this.teleConsultants = [];
    },
    getPriceByZone(zone, array) {
      let price = 0;
      for (var i = 0; i < array.length; i++) {
        if (array[i].zone.toString() === zone.toString()) {
          price = array[i].price;
          break;
        }
      }
      return price;
    },
    async changeSeller(seller) {
      if (this.currentUser.type != 'Seller' && seller) {
        if (this.formData.customer.city)
          await this.getFeesShipByCity(this.formData.seller, this.formData.customer.city);

        this.isDisabled = false;
        if (this.formData.details) {
          if (this.formData.details[0]) {
            if (this.formData.details[0].product.seller != seller._id) {
              this.formData.details = [];
            }
          }
        }
      } else {
        this.isDisabled = true;
      }
    },
    searchUsers: _.debounce(async function (search, userType) {
      if (this.selectCountry) {
        const filter = {
          type: userType,
          limit: 10,
          countries: this.selectCountry,
          name: search,
        };

        try {
          const res = await this.$server.find("users", filter);

          if (userType === "Seller") {
            this.sellers = res.content.results || [];
          } else if (userType === "TeleConsultant") {
            this.teleConsultants = res.content.results || [];
          }

        } catch (error) {
          console.error(`Error fetching ${userType}s:`, error);
        }
      }
    }, 500),
  },
};
</script>

<style>
.w-fit {
  width: fit-content;
}

.toggle__dot {
  transition: all 0.3s ease-in-out;
}

input:checked~.toggle__dot {
  transform: translateX(100%);
  background-color: #68d391;
}

/* Animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}

@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.vs__dropdown-toggle {
  border: none;
}
</style>
